import React from 'react';
import {
  Control,
  Controller,
  FieldValues,
  get,
  Path,
  PathValue,
  useFormState,
} from 'react-hook-form';
import clsx from 'clsx';
import ControllerTextarea from '../ui/ControllerTextarea';

interface StyledTextareaProps<FieldsType extends FieldValues> {
  title?: string;
  titleIcon?: React.ReactNode;
  name: Path<FieldsType>;
  control: Control<FieldsType>;
  defaultValue?: PathValue<FieldsType, Path<FieldsType>>;
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
  placeholder?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
  rows?: number;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const StyledTextarea = <FieldsType extends FieldValues>({
  title,
  titleIcon,
  control,
  name,
  defaultValue,
  className,
  placeholder,
  disabled = false,
  icon,
  rows,
  onChange,
}: StyledTextareaProps<FieldsType>) => {
  const { errors } = useFormState({ control });
  const errorMessage = get(errors, name + '.message') as unknown as string;

  return (
    <div className={clsx('flex flex-col w-full gap-1.5', className)}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <ControllerTextarea
            field={field}
            title={title}
            titleIcon={titleIcon}
            errorMessage={errorMessage}
            name={name}
            placeholder={placeholder}
            disabled={disabled}
            icon={icon}
            rows={rows}
            onChange={(event) => {
              const returnValue = field.onChange(event);
              if (onChange) {
                onChange(event);
              }
              return returnValue;
            }}
          />
        )}
        defaultValue={defaultValue}
      />
      {errorMessage !== '' && (
        <p className="text-sm leading-6 font-medium text-error-500">
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default StyledTextarea;
